import userApi from '@/api/user';
import groupApi from '@/api/group';
import permissionApi from '@/api/permission';

const UPDATE_PERMISSION = 'UPDATE_PERMISSION';
const ADD_PERMISSION = 'ADD_PERMISSION';
const REMOVE_PERMISSION = 'REMOVE_PERMISSION';
const CLEAN_STATE = 'CLEAN_STATE';
const SET_USERS_AND_GROUPS = 'SET_USERS_AND_GROUPS';

const state = {
  usersAndGroups: []
};

const getters = {
  getItemsWithoutPermissions: (state) => {
    return state.usersAndGroups.filter(item => !item.permissions);
  },
  getItemsWithPermissions: state => {
    return state.usersAndGroups.filter(item => item.permissions);
  }
};
/*
 Item format:
 {
    label: String
    value: {
      id: Number,
      name: String,
      type: ['user'|'group'],
      users: Array, // Only groups
      groups: Array, // Only users
    },
    permissions: {
      canRead: Bool,
      canEdit: Bool,
      canShare: Bool,
    }
 }
*/

const mutations = {
  [SET_USERS_AND_GROUPS] (state, usersAndGroups) {
    state.usersAndGroups = usersAndGroups;
  },
  [UPDATE_PERMISSION] (state, { type, id, permissionType, permissionValue }) {
    let index;
    let updatedItem;
    for (let i in state.usersAndGroups) {
      const item = state.usersAndGroups[i];
      if (item.value.type === type && item.value.id === id) {
        index = i;
        updatedItem = {
          label: item.label,
          value: item.value,
          permissions: item.permissions
        };
        if (permissionType === 'edit') {
          updatedItem.permissions.canEdit = permissionValue;
        } else if (permissionType === 'share') {
          updatedItem.permissions.canShare = permissionValue;
        }
        break;
      }
    }
    state.usersAndGroups.splice(index, 1, updatedItem);
  },
  [ADD_PERMISSION] (state, newItem) {
    const index = state.usersAndGroups.map(e => e.value.type + e.value.id).indexOf(newItem.value.type + newItem.value.id);
    state.usersAndGroups.splice(index, 1, newItem);
  },
  [REMOVE_PERMISSION] (state, oldItem) {
    const index = state.usersAndGroups.map(e => e.value.type + e.value.id).indexOf(oldItem.value.type + oldItem.value.id);
    state.usersAndGroups.splice(index, 1, {
      label: oldItem.label,
      value: oldItem.value
    });
  },
  [CLEAN_STATE] (state) {
    state.usersAndGroups = [];
  }
};

const actions = {
  retrievePermissionData: ({ commit, getters }, { context, objectId, objectType }) => {
    const promises = [];
    promises.push(
      userApi.getPermissionUsers(context),
      groupApi.getPermissionGroups(context),
      permissionApi.getPermissionsByUser(context, objectId, objectType),
      permissionApi.getPermissionsByGroup(context, objectId, objectType));

    Promise.all(promises).then(responses => {
      const username = getters.getUserAccount.username;
      const users = responses[0].filter(user => user.label !== username);
      const groups = responses[1];
      const permissionsByUsers = responses[2];
      const permissionsByGroups = responses[3];
      const usersAndGroups = [];
      for (let user of users) {
        user.permissions = getPermissionsForItem(user.value.id, permissionsByUsers);
        usersAndGroups.push(user);
      }
      for (let group of groups) {
        group.permissions = getPermissionsForItem(group.value.id, permissionsByGroups);
        usersAndGroups.push(group);
      }
      commit(SET_USERS_AND_GROUPS, usersAndGroups);
    });
  },
  updatePermission: ({ commit }, { context, permissionType, permissionValue, objectId, objectType, userOrGroup, userOrGroupId }) => {
    if (permissionValue) {
      permissionApi.addPermission(context, permissionType, objectId, objectType, userOrGroup, userOrGroupId);
    } else {
      permissionApi.deletePermission(context, permissionType, objectId, objectType, userOrGroup, userOrGroupId);
    }
    commit(UPDATE_PERMISSION, {
      type: userOrGroup,
      id: userOrGroupId,
      permissionType,
      permissionValue
    });
  },
  addPermission: ({ commit }, { context, objectId, objectType, item }) => {
    const promises = [];
    if (item.permissions.canEdit) {
      promises.push(permissionApi.addPermission(context, 'edit', objectId, objectType, item.value.type, item.value.id));
    }
    if (item.permissions.canRead) {
      promises.push(permissionApi.addPermission(context, 'read', objectId, objectType, item.value.type, item.value.id));
    }
    if (item.permissions.canShare) {
      promises.push(permissionApi.addPermission(context, 'share', objectId, objectType, item.value.type, item.value.id));
    }

    return new Promise((resolve, reject) => {
      Promise.all(promises).then(() => {
        commit(ADD_PERMISSION, item);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  removePermission: ({ commit }, { context, objectId, objectType, item }) => {
    const promises = [];
    if (item.permissions.canEdit) {
      promises.push(permissionApi.deletePermission(context, 'edit', objectId, objectType, item.value.type, item.value.id));
    }
    if (item.permissions.canRead) {
      promises.push(permissionApi.deletePermission(context, 'read', objectId, objectType, item.value.type, item.value.id));
    }
    if (item.permissions.canShare) {
      promises.push(permissionApi.deletePermission(context, 'share', objectId, objectType, item.value.type, item.value.id));
    }

    return new Promise((resolve, reject) => {
      Promise.all(promises).then(() => {
        commit(REMOVE_PERMISSION, item);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  cleanState: ({ commit }) => {
    commit(CLEAN_STATE);
  }
};

const getPermissionsForItem = (id, permissionsByItem) => {
  let permissions;
  for (let permission of permissionsByItem) {
    if (permission.id === id) {
      permissions = {
        canRead: permission.canRead,
        canEdit: permission.canEdit,
        canShare: permission.canShare
      };
    }
  }
  return permissions;
};
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/permissions/index.js